<template>
  <div>
    <poly-integer-reference-create
      :ams_template="ams_template"
      :reroute="reroute"
    ></poly-integer-reference-create>
  </div>
</template>

<script>
import PolyIntegerReferenceCreate from './PolyIntegerReferenceCreate.vue'

export default {
  components: {
    PolyIntegerReferenceCreate
  },
  props: {
    reroute: {
      Type: Boolean,
      default: true
    },
    ams_template: {
      Type: Object
    }
  }
}
</script>
